import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {
  @Input() dialogType: any;
  @Input() showButton: boolean = false;
  @Output() btnAction: EventEmitter<any> = new EventEmitter();

  icon = 'loading'
  platform: any;

  constructor(
  ) { }

  async ngOnInit() {
    if (this.dialogType === 'update_warning') {
      this.icon = 'dialog-confirmation';
    } else if (this.dialogType === 'missmatch') {
      this.icon = 'dialog-error';
    } else {
      console.log("PDP_PAGE_SUCCESS");
      this.icon = 'dialog-success';
    }
    setTimeout(() => {
      this.platform = localStorage.getItem('platform');
    }, 100);
  }

  doAction() {
    this.btnAction.emit();
  }

  close() {
  }
}
